module.exports = __webpack_public_path__ + "img/audio-description.f86dd42f.svg";